import { GridStackNode } from 'gridstack';
import { Observable } from 'rxjs';

import { createProviderToken } from '@recruitee/common';
import { AnyWidgetDef } from '@recruitee/dashboard-types';

export const { inject: injectDashboardWidgets, provide: provideDashboardWidget } =
  createProviderToken<Observable<AnyWidgetDef>>('DASHBOARD_WIDGET_TOKEN')(true);

export const gridstackMoveToTop = (node: GridStackNode) => {
  if (!node.grid) return;

  node.grid.setAnimation(false);
  node.grid.engine.moveNode(node, { x: 0, y: 0 });
  node.grid.setAnimation(true);
};
